import NoteneticButton from "src/control-components/button"
import "../../../app-modules/documents/document-list-chart/style.css"

export const HeaderComponent = ({ title, onClick, isLoading }) => {
    return <div className="flexBox">
        <h5 style={{ margin: 0 }}>
            {title}
        </h5>
        <NoteneticButton
            preset="bordered"
            text=""
            tooltip="Export to Excel"
            iconName="fa-regular fa-file-excel"
            onClick={onClick}
            isLoading={isLoading}
            disabled={isLoading}
        />
    </div>
}